import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { OtomatikFaturaListIstegi } from '../../../../services/OtomatikFaturaService';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: OtomatikFaturaListIstegi
    setFilter: React.Dispatch<React.SetStateAction<OtomatikFaturaListIstegi>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    copyFunction: () => void
    onSearchSubmit: (e: any) => void
}

const OtomatikFaturaListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    setFilter,
    selectedCount,
    deleteFunction,
    updateFunction,
    copyFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                    <button disabled={selectedCount != 1} onClick={() => copyFunction()} className='btn btn-sm btn-flex btn-light-info'>
                        <i className='fa fa-copy fs-6 me-1' />
                        Kopyala
                    </button>
                )
            }

            <div className='m-0'>
                <a onClick={() => navigate('/otomatikfatura/gecmis')} className='btn btn-sm fw-bold btn-light-primary'>
                    Çalışma Geçmişi
                </a>
            </div>

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                    <div className='m-0'>
                        <a onClick={() => navigate('/otomatikfatura/listadd')} className='btn btn-sm fw-bold btn-primary'>
                            Yeni Kural Ekle
                        </a>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default OtomatikFaturaListFilters;
